module.exports = __webpack_public_path__ + "img/QOOKER_Box00.8023d4de.jpg";